module.exports = __webpack_public_path__ + "assets/img/type_4.cb4e35bd.png";